<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客服管理</el-breadcrumb-item>
      <el-breadcrumb-item>内容记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-content: flex-start;align-items: flex-end">
      <el-button size="mini" plain @click="showContentDialog">添加记录</el-button>
      <el-date-picker
        v-model="contentRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select v-model="answerId" size="mini" placeholder="请选择接听人" clearable
        @change="selectAnswer">
        <el-option
          v-for="item in answers"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="contentType" size="mini" placeholder="请选择信息类型" clearable
        @change="selectContentType">
        <el-option
          v-for="item in infos"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button size="mini" plain @click="loadContent">查询</el-button>
    </div>

    <el-table height="510px" :data="contentList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
      <el-table-column
        label="操作"
        fixed="fixed"
        align="center"
        width="100">
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-around">
            <el-link icon="el-icon-edit" type="primary" @click="showEditContentDialog(scope.row)"></el-link>
            <el-link icon="el-icon-delete" type="primary"  @click="deleteContent(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="contentDate"
        label="记录时间"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="来电号码"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="areaName"
        label="所属区域"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="answerName"
        label="接听人"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="longTime"
        label="时长"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="phoneType"
        label="来电类型"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        label="来电内容"
        align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.content }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.content }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="feedBack"
        label="反馈人"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="result"
        label="处理结果"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="contentTypeName"
        label="信息类型"
        align="center"
        width="150">
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="contentCurrentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="contentPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="contentPageTotal">
      </el-pagination>
    </div>

    <el-dialog
      title="编辑记录"
      :visible.sync="contentVisible"
      width="70%"
      @close="closeContentDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-content: space-around">
          <div style="width: 50%">
            <span style="width: 30%">来电号码:</span>
            <el-input v-model="content.phone" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">所属区域:</span>
            <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                       style="width: 70%" size="mini" @change="selectArea">
              <el-option
                v-for="item in areas"
                :key="item.id"
                :label="item.orgName"
                :value="item.id">
              </el-option>
            </el-select>
            <el-input v-model="content.areaName" v-if="orgLevel > 1" readonly size="mini" style="width: 70%;" />
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">接听人员:</span>
            <el-select v-model="content.answerId" size="mini" @change="selectAddAnswer"
                       placeholder="请选择接听人" style="width: 70%">
              <el-option
                v-for="item in answers"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">信息类型:</span>
            <el-select v-model="content.contentType" size="mini" @change="selectAddContentType"
                       placeholder="请选择信息类型"  style="width: 70%">
              <el-option
                v-for="item in infos"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">来电时长:</span>
            <el-input v-model="content.longTime" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">来电类型:</span>
            <el-input v-model="content.phoneType" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">反馈人员:</span>
            <el-input v-model="content.feedBack" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">处理结果:</span>
            <el-input v-model="content.result" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
        <div style="display: flex;justify-content: flex-start;margin-top: 15px">
          <span style="width: 7%">来电内容:</span>
          <el-input v-model="content.content" placeholder="请输入内容" type="textarea"
                      size="mini" style="width: 93%;"/>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeContentDialog">取 消</el-button>
        <el-button size="mini" @click="createContent">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑记录"
      :visible.sync="editContentVisible"
      width="70%"
      @close="closeEditContentDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-content: space-around">
          <div style="width: 50%">
            <span style="width: 30%">来电号码:</span>
            <el-input v-model="editContent.phone" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">所属区域:</span>
            <el-select value filterable v-model="editContent.areaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                       style="width: 70%" size="mini" @change="selectArea">
              <el-option
                v-for="item in areas"
                :key="item.id"
                :label="item.orgName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-input v-model="editContent.areaName" v-if="orgLevel > 1" readonly size="mini" style="width: 70%;" />
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">接听人员:</span>
            <el-select v-model="editContent.answerId" size="mini" @change="selectEditAnswer"
                       placeholder="请选择接听人" style="width: 70%">
              <el-option
                v-for="item in answers"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">信息类型:</span>
            <el-select v-model="editContent.contentType" size="mini" @change="selectEditContentType"
                       placeholder="请选择信息类型"  style="width: 70%">
              <el-option
                v-for="item in infos"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">来电时长:</span>
            <el-input v-model="editContent.longTime" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">来电类型:</span>
            <el-input v-model="editContent.phoneType" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">反馈人员:</span>
            <el-input v-model="editContent.feedBack" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">处理结果:</span>
            <el-input v-model="editContent.result" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
        <div style="display: flex;justify-content: flex-start;margin-top: 15px">
          <span style="width: 7%">来电内容:</span>
          <el-input v-model="editContent.content" placeholder="请输入内容" type="textarea"
                    size="mini" style="width: 93%;"/>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeEditContentDialog">取 消</el-button>
        <el-button size="mini" @click="editContentMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      shopId:'',
      userId:'',
      orgLevel:0,
      orgName:'',
      contentType:'',
      contentList:[],
      answerId:'',
      contentRequest:{
        selectDate:'',
        orgId: '',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        areaId:'',
        shopId:'',
        answerId:'',
        contentType:''
      },
      content:{
        phone:'',
        areaId:'',
        areaName:'',
        answerId: '',
        answerName:'',
        contentType: '',
        contentTypeName:'',
        longTime:'',
        phoneType:'',
        feedBack:'',
        result:'',
        content:'',
        creator:''
      },
      areas: [],
      selectAreaId:'',
      answers:[
        {id:731, name:'侯绪婷'},
        {id:1217, name:'刘婧雅'},
        {id:11, name:'尹永健'},
      ],
      infos:[
        {id:1, name:'工作时间>1min'},
        {id:2, name:'休息时间接听'},
        {id:3, name:'投诉'},
        {id:4, name:'疫情居家期间'},
        {id:5, name:'退款'},
        {id:6, name:'成交'},
      ],
      contentCurrentPage: 1,
      contentPageSize:20,
      contentPageTotal:0,
      contentVisible:false,

      editContentVisible:false,
      editContent:'',
    }
  },
  methods: {
    showContentDialog(){
      this.clear();
      this.contentVisible = true;
    },
    closeContentDialog(){
      this.contentVisible = false;
    },
    selectKpiData(date){
      if (date === null || date === ''){
        this.contentRequest.startDate = this.getCurrentDate();
        this.contentRequest.endDate = this.getCurrentDate();
      } else {
        this.contentRequest.startDate = date[0];
        this.contentRequest.endDate = date[1];
      }
    },
    handleSizeChange(val) {
      this.contentPageSize = val;
      this.loadContentList();
    },
    handleCurrentChange(val) {
      this.contentCurrentPage = val;
      this.loadContentList();
    },
    async loadAreas(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.shopId}`);
      if (res.code === 200){
        this.areas = res.data;
      }
    },
    async createContent(){
      if (this.content.phone === ''){
        return this.$message.warning("请填写来电号码")
      }
      if (this.content.areaId === 0){
        return this.$message.warning("请选择区域")
      }
      if (this.content.answerId === 0){
        return this.$message.warning("请选择接听人")
      }
      if (this.content.contentType === 0){
        return this.$message.warning("请选择信息类型")
      }
      if (this.content.longTime === ''){
        return this.$message.warning("请填写时长")
      }
      if (this.content.content === ''){
        return this.$message.warning("请填写内容")
      }
      this.content.creator = this.userId;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/new/content`, this.content);
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.closeContentDialog();
      this.loadContent();
    },
    selectArea(data){
      this.content.areaId = data;
    },
    selectAnswer(data){
      this.contentRequest.answerId = data;
      this.answers.map((item) =>{
        if (item.id === data){
          this.content.answerName = item.name;
        }
      })
    },
    selectAddAnswer(data){
      this.answers.map((item) =>{
        if (item.id === data){
          this.content.answerName = item.name;
        }
      })
    },
    selectContentType(data){
      this.contentRequest.contentType = data;
      this.infos.map((item) =>{
        if (item.id === data){
          this.content.contentTypeName = item.name;
        }
      })
    },
    selectAddContentType(data){
      this.infos.map((item) =>{
        if (item.id === data){
          this.content.contentTypeName = item.name;
        }
      })
    },
    selectEditAnswer(data){
      this.editContent.answerId = data;
      this.answers.map((item) =>{
        if (item.id === data){
          this.editContent.answerName = item.name;
        }
      })
    },
    selectEditContentType(){
      this.editContent.contentType = data;
      this.infos.map((item) =>{
        if (item.id === data){
          this.editContent.contentTypeName = item.name;
        }
      })
    },
    loadContent(){
      this.contentRequest.pageNum = this.contentCurrentPage;
      this.contentRequest.pageSize = this.contentPageSize;
      if(this.contentRequest.startDate == ''){
        this.contentRequest.startDate = this.getCurrentDate();
        this.contentRequest.endDate = this.getCurrentDate();
      }
      this.loadContentCount();
      this.loadContentList();
    },
    async loadContentCount(){
      const {data:res} = await this.$http.post(`/content/count`, this.contentRequest);
      this.contentPageTotal = res.totalPage;
    },
    async loadContentList(){
      const {data:res} = await this.$http.post(`/content/list`, this.contentRequest);
      this.contentList = res.data;
    },
    async loadAreaByShop(){
      const {data:res} = await this.$http.get(`/load/area/${this.shopId}`);
      this.content.areaId = res.data.id;
      this.content.areaName = res.data.orgName;
    },
    showEditContentDialog(data){
      this.editContent = data;
      this.editContentVisible = true;
    },
    closeEditContentDialog(){
      this.editContentVisible = false;
    },
    async editContentMethod(){
      if (this.editContent.phone === ''){
        return this.$message.warning("请填写来电号码")
      }
      if (this.editContent.areaId === 0){
        return this.$message.warning("请选择区域")
      }
      if (this.editContent.answerId === 0){
        return this.$message.warning("请选择接听人")
      }
      if (this.editContent.contentType === 0){
        return this.$message.warning("请选择信息类型")
      }
      if (this.editContent.longTime === ''){
        return this.$message.warning("请填写时长")
      }
      if (this.editContent.content === ''){
        return this.$message.warning("请填写内容")
      }
      this.editContent.creator = this.userId;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/edit/content`, this.editContent);
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.closeEditContentDialog();
      this.loadContent();
    },
    async deleteContent(row){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/delete/content`, row);
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.closeEditContentDialog();
      this.loadContent();
    },
    clear(){
      this.selectAreaId = '';
      this.content.phone = '';
      this.content.areaId = '';
      this.content.areaName = '';
      this.content.answerId = '';
      this.content.answerName = '';
      this.content.contentType = '';
      this.content.contentTypeName = '';
      this.content.longTime = '';
      this.content.phoneType = '';
      this.content.feedBack = '';
      this.content.result = '';
      this.content.content = '';
      this.content.creator = '';
    },
    getCurrentDate(){
      let today = new Date();
      let year = today.getFullYear();//获取年份
      let month = today.getMonth() + 1;//获取月份
      let day = today.getDate();//获取日期
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + "-" + month + "-" + day;
    }
  },
  created() {
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.orgName = window.sessionStorage.getItem('orgName');
    this.loadContent();
    if (this.orgLevel == 1){
      this.loadAreas();
    }
    if (this.orgLevel == 2){
      this.content.areaId = this.shopId;
      this.content.areaName = this.orgName;
    }
    if (this.orgLevel == 3){
      this.loadAreaByShop();
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Contents.vue